var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { baseKeymap, chainCommands, createParagraphNear, joinBackward, joinDown, joinUp, lift, liftEmptyBlock, newlineInCode, selectNodeBackward, selectParentNode, } from 'prosemirror-commands';
import { redo } from 'prosemirror-history';
import { keydownHandler } from 'prosemirror-keymap';
import { Plugin, PluginKey } from 'prosemirror-state';
import { filterData, groupData, toArray } from '../../libs';
import { createCtrlPlugin } from '../ctrl-plugin';
import { splitBlock } from '.';
import { clearAtHead, deleteSelection, deleteZeroChar, insertBreak, selectBefore, splitBlockKeepMarks, undo, } from './behavior';
var BASIC_KEYMAP_KEY = new PluginKey('basicKeymap');
var DEFAULT_KEYMAP_KEY = new PluginKey('defaultKeymap');
var CUSTOM_KEYMAP_KEY = new PluginKey('customKeymap');
// to prevent override basemap's basic map
var backspace = chainCommands(deleteSelection, selectBefore, joinBackward, selectNodeBackward, clearAtHead, deleteZeroChar);
var createBasicKeymapPlugin = function (config) {
    var keepMarks = config.keepMarks;
    return new Plugin({
        key: BASIC_KEYMAP_KEY,
        state: {
            init: function () {
                return null;
            },
            apply: function (tr, val) {
                var data = tr.getMeta(BASIC_KEYMAP_KEY);
                if ((data === null || data === void 0 ? void 0 : data.keepMarks) !== undefined) {
                    keepMarks = Boolean(data.keepMarks);
                }
                if (data)
                    return data;
                return val;
            },
        },
        props: {
            handleKeyDown: keydownHandler({
                Enter: chainCommands(newlineInCode, createParagraphNear, liftEmptyBlock, function (state, dispatch) {
                    return keepMarks ? splitBlockKeepMarks(state, dispatch) : splitBlock(state, dispatch);
                }),
                'Mod-z': undo,
                'Mod-y': redo,
                'Shift-Mod-z': redo,
                Backspace: backspace,
                'Alt-ArrowUp': joinUp,
                'Alt-ArrowDown': joinDown,
                'Mod-Bracketleft': lift,
                Escape: selectParentNode,
                'Shift-Enter': insertBreak,
            }),
        },
    });
};
var defaultKeymapPlugin = new Plugin({
    key: DEFAULT_KEYMAP_KEY,
    props: {
        handleKeyDown: keydownHandler(baseKeymap),
    },
});
var chainSylKeymap = function (adapter) {
    var handlers = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        handlers[_i - 1] = arguments[_i];
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return handlers.some(function (handler) { return handler.apply(void 0, __spreadArray([adapter], args, false)); });
    };
};
var composeKeymap = function (adapter, keyMaps) {
    return Object.keys(keyMaps).reduce(function (res, key) {
        res[key] = chainSylKeymap.apply(void 0, __spreadArray([adapter], keyMaps[key], false));
        return res;
    }, {});
};
var KeymapCtrl = /** @class */ (function () {
    function KeymapCtrl(adapter, configs) {
        var _this = this;
        this.props = {};
        this.keyMapConfig = {};
        this.spec = {
            props: this.props,
        };
        this.handleProps = function () {
            _this.props.handleKeyDown = keydownHandler(composeKeymap(_this.adapter, _this.keyMapConfig));
        };
        this.adapter = adapter;
        if (configs)
            this.register(configs);
    }
    KeymapCtrl.prototype.register = function (registerConfigs, prioritized) {
        var _this = this;
        if (prioritized === void 0) { prioritized = false; }
        toArray(registerConfigs).forEach(function (keymap) {
            Object.keys(keymap).forEach(function (key) {
                groupData(_this.keyMapConfig, key, keymap[key], prioritized);
            });
        });
        this.handleProps();
    };
    KeymapCtrl.prototype.unregister = function (registerConfigs) {
        var _this = this;
        toArray(registerConfigs).forEach(function (keymap) {
            Object.keys(keymap).forEach(function (key) {
                filterData(_this.keyMapConfig, key, keymap[key]);
            });
        });
        this.handleProps();
    };
    return KeymapCtrl;
}());
var createCustomKeymapPlugins = function (adapter, customKeyMaps) {
    var ctrl = new KeymapCtrl(adapter, customKeyMaps);
    return createCtrlPlugin(ctrl.spec, ctrl);
};
export { BASIC_KEYMAP_KEY, composeKeymap, createBasicKeymapPlugin, createCustomKeymapPlugins, CUSTOM_KEYMAP_KEY, DEFAULT_KEYMAP_KEY, defaultKeymapPlugin, };
//# sourceMappingURL=keymap.js.map